import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue'
import vuetify from '../plugins/vuetify.plugin.js';
import Axios from 'axios'
import i18n from '../i18n.js';

import App from './SharingApp.vue'

import LoadingIndicator from '../components/LoadingIndicator.vue';

import HelperPlugin from "../plugins/helper.plugin";

import Heading from "../components/Heading";
import AppBar from "../components/AppBar";

Vue.component('hb-loading-indicator', LoadingIndicator);
Vue.component('hb-heading', Heading);
Vue.component('hb-app-bar', AppBar);

Vue.use(HelperPlugin);

const baseUrl = process.env.VUE_APP_API_BASEURL;
const hasCustomBaseUrl = baseUrl != null;
if (hasCustomBaseUrl) {
  Axios.defaults.baseURL = process.env.VUE_APP_API_BASEURL
}
Vue.config.productionTip = false;


// eslint-disable-next-line no-unused-vars
const vue = new Vue({
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
